// Helper to map MIME types to user-friendly names
export const mimeToName = (mime: string) => {
	if (mime === 'application/pdf') return '.pdf';
	if (mime === 'image/png') return '.png';
	if (mime === 'image/jpeg') return '.jpeg';
	if (mime === 'image/jpg') return '.jpg';
	if (mime === 'image/gif') return '.gif';
	if (mime === 'image/bmp') return '.bmp';
	if (mime === 'image/webp') return '.webp';
	if (mime === 'application/msword') return '.doc';
	if (mime === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') return '.docx';
	if (mime === 'application/vnd.ms-excel') return '.xls';
	if (mime === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') return '.xlsx';
	if (mime === 'text/plain') return '.txt';
	// fallback: take subtype after /
	const parts = mime.split('/');
	return parts.length === 2 ? `.${parts[1]}` : mime;
};
